export default {"src":"/_next/static/media/consent_app.75cdc6fd.svg","height":36,"width":36,"blurWidth":0,"blurHeight":0};